import { render, staticRenderFns } from "./OccupationsPage.vue?vue&type=template&id=171d56a8&scoped=true&"
import script from "./OccupationsPage.vue?vue&type=script&lang=js&"
export * from "./OccupationsPage.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=171d56a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171d56a8",
  null
  
)

export default component.exports